import { render, staticRenderFns } from "./dynamic-add.vue?vue&type=template&id=52d8ee54&scoped=true"
import script from "./dynamic-add.vue?vue&type=script&lang=js"
export * from "./dynamic-add.vue?vue&type=script&lang=js"
import style0 from "./dynamic-add.vue?vue&type=style&index=0&id=52d8ee54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8ee54",
  null
  
)

export default component.exports